// eslint-disable-next-line @typescript-eslint/ban-types
type RequestExtras = Record<'atlRequestId' | 'atlTraceId' | (string & {}), string | null>;

export class RequestError extends Error {
  name = 'RequestError';
  statusText = '';
  statusCode = 0;
  extras: RequestExtras;
  constructor(statusText: string, statusCode = 0, extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(`${statusText} (${statusCode})`);
    this.statusText = statusText;
    this.statusCode = statusCode;
    this.extras = extras;
  }
}
export class GraphQLFetchError extends RequestError {
  constructor(statusText = '', statusCode = 0, extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(statusText, statusCode, extras);
    this.name = 'GraphQLFetchError';
  }
}

export class ForbiddenError extends RequestError {
  constructor(statusText = '', extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(statusText, 403, extras);
    this.name = 'ForbiddenError';
  }
}

export class UnauthorizedError extends RequestError {
  constructor(statusText = '', extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(statusText, 401, extras);
    this.name = 'UnauthorizedError';
  }
}

export class BadRequestError extends RequestError {
  constructor(statusText = '', statusCode = 400, extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(statusText, statusCode, extras);
    this.name = 'BadRequestError';
  }
}

export class NotFound extends RequestError {
  constructor(statusText = '', extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(statusText, 404, extras);
    this.name = 'NotFound';
  }
}

export class InternalServerError extends RequestError {
  constructor(statusText = '', extras: RequestExtras = { atlRequestId: null, atlTraceId: null }) {
    super(statusText, 500, extras);
    this.name = 'InternalServerError';
  }
}

export class RelayRequiredFieldError extends RequestError {
  name = 'RelayRequiredFieldError';
}
